import { Autocomplete, Box, TextField } from "@mui/material";
import { Activite } from "../../../../models/Activite";
import { useAppDispatch } from "../../../../redux/store";
import {
  useGetSectionsQuery,
  useUpdateGroupProduitMutation,
  useUpdateProduitMutation,
} from "../../../../redux/features/cache";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { addRequestToSend } from "../../../../redux/features/appStateSlice";
import { Section } from "../../../../models/Section";
import { RequestToSend } from "../../../../models/RequestToSend";
import { Produit } from "../../../../models/Produit";

export interface IFormEditProduit {
  produit: Produit;
  section: Section;
  allCode: Activite[];
  setUnsaved: Dispatch<SetStateAction<boolean>>;
}

export default function FormEditProduit({
  produit,
  allCode,
  setUnsaved,
  section,
}: IFormEditProduit) {
  const [updateGroup] = useUpdateGroupProduitMutation();
  const { data: sections = [] as Section[] } = useGetSectionsQuery({
    div: "",
    simple: true,
    user: "",
    rech: "",
    treeView: false,
  });
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [currentCollection, setCurrentCollection] = useState<string>(
    produit.prod_collection
  );
  const [currentSection, setCurrentSection] = useState<Section | null>(
    sections.find((item) => item.plans_seq === section.plans_seq)
      ? sections.find((item) => item.plans_seq === section.plans_seq)!
      : null
  );
  const [currentActivite, setCurrentActivite] = useState<Activite | null>(
    allCode.find((item) => item.act_cd === produit.act_cd)
      ? allCode.find((item) => item.act_cd === produit.act_cd)!
      : null
  );
  const dispatch = useAppDispatch();
  const [updateProduit] = useUpdateProduitMutation();

  useEffect(() => {
    setUnsaved(isDirty);
  }, [isDirty, setUnsaved]);

  const handleSub = async () => {
    let sectionUpdate = {
      plans_seq: currentSection?.plans_seq,
      prod_num: produit.prod_num,
    };
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Modifier section du produit ${produit.prod_num}`,
          updateGroup,
          () => {},
          {},
          sectionUpdate,
          []
        )
      )
    );
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Modifier produit ${produit.prod_num}`,
          updateProduit,
          () => {
            setIsDirty(false);
          },
          {},
          {
            ...produit,
            act_cd: currentActivite?.act_cd,
            prod_collection: currentCollection,
            plans_seq: currentSection?.plans_seq,
          },
          []
        )
      )
    );
  };

  return (
    <div>
      {produit && (
        <Box sx={{ display: "flex" }}>
          <TextField
            value={currentCollection}
            onChange={(e) => {
              if (!isDirty) setIsDirty(true);
              setCurrentCollection(e.target.value);
            }}
            label={"Collection"}
            sx={{ width: 300, m: 1 }}
          />
          <Autocomplete
            value={currentSection}
            options={sections}
            getOptionLabel={(sec) => `${sec.plans_nom}`}
            onInputChange={async (event, newInputValue) => {
              if (!isDirty && newInputValue !== currentSection?.plans_nom)
                setIsDirty(true);
              let id = sections.find((item) => item.plans_nom === newInputValue)
                ? sections.find((item) => item.plans_nom === newInputValue)!
                : null;
              setCurrentSection(id);
            }}
            sx={{ width: 300, m: 1 }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Section"
                sx={{ color: "#233044", background: "white" }}
              />
            )}
          />
          <Autocomplete
            value={currentActivite}
            options={allCode}
            getOptionLabel={(sec) => `${sec.act_aff}`}
            onInputChange={async (event, newInputValue) => {
              if (!isDirty && newInputValue !== currentActivite?.act_aff)
                setIsDirty(true);
              let id = allCode.find((item) => item.act_aff === newInputValue)
                ? allCode.find((item) => item.act_aff === newInputValue)!
                : null;
              setCurrentActivite(id);
            }}
            sx={{ width: 300, m: 1 }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Code d'activité"
                sx={{ color: "#233044", background: "white" }}
              />
            )}
          />
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!isDirty ? "custom-disabled" : ""}`}
            onClick={handleSub}
          >
            <span className={`k-icon k-font-icon k-i-save k-icon-xl`}></span>
          </span>
        </Box>
      )}
    </div>
  );
}
